import { Map } from 'immutable';
import { JsonSchemaValidationErrors } from './JsonSchemaValidationErrors';

export const emptyJsonSchemaValidationErrors: JsonSchemaValidationErrors = Map();
